<template>
  <div class="review-details details">
    <div class="close" v-on:click="close()">
      <b-icon icon="close" size="is-large" />
    </div>
    <nav>
      <div class="prev nav-control" @click="prev()">
        <b-icon icon="chevron-left" size="is-large" />
      </div>
      <div class="next nav-control" @click="next()">
        <b-icon icon="chevron-right" size="is-large" />
      </div>
    </nav>
    <div class="slide-show" :class="showWrapperClasses">
      <review-slide
        v-for="slide in loadedSet"
        :key="['slide', slide.index].join('-')"
        :slide="slide"
        :active="slide.index === currIndex"
        :total="numSlides"
        :mayMark="mayMark"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import filters from "../mixins/filters";
import ReviewSlide from "./ReviewSlide";
import { bus } from "../main";

export default {
  name: "ReviewDetails",
  components: {
    ReviewSlide
  },
  props: {
    data: {
      type: Object,
      default() {
        return {
          numSubmissions: 0,
          numWorks: 0,
          numSlides: 0,
          numImages: 0,
          numVideo: 0,
          numAudio: 0,
          slides: []
        };
      }
    },
    filter: {
      type: String,
      default: "submitted"
    },
    start: {
      type: Number,
      default: 0
    },
    mayMark: {
      type: Boolean,
      default: false,
    }
  },
  mixins: [filters],
  created() {
    bus.$on("next", this.handleNext);
    bus.$on("prev", this.handlePrev);
    bus.$on("escape", this.handleClose);
  },
  mounted() {
    this.setPath();
    if (this.start > 0) {
      this.currIndex = this.start;
    }
  },
  beforeDestroy() {
    bus.$off("next", this.handleNext);
    bus.$off("prev", this.handlePrev);
    bus.$off("escape", this.handleClose);
  },
  data() {
    return {
      currIndex: 0,
      switching: false,
      moving: false
    };
  },
  watch: {
    currIndex(cv, pv) {
      if (cv !== pv) {
        this.setPath();
        this.switching = true;
        setTimeout(() => {
          this.switching = false;
        }, 3000);
      }
    },
    filter(cv, pv) {
      if (cv !== pv) {
        this.currIndex = this.start;
        this.setPath();
      }
    }
  },
  computed: {
    ...mapGetters(["settings", "options"]),
    slides() {
      return this.data.slides instanceof Array ? this.data.slides : [];
    },
    loadedSet() {
      const max = 3;
      const num = this.slides.length;
      const lastIndex = num - 1;
      const limit = num < max ? num : max;
      const fixedBefore = Math.floor(limit / 2);
      const maxBefore =
        this.currIndex < lastIndex - fixedBefore
          ? fixedBefore
          : fixedBefore + (lastIndex - this.currIndex);
      let startIndex =
        this.currIndex < fixedBefore ? 0 : this.currIndex - maxBefore;
      if (startIndex < 0) {
        startIndex = 0;
      }
      return this.slides.slice(startIndex, startIndex + limit);
    },
    numSubmissions() {
      return this.data.numSubmissions;
    },
    numWorks() {
      return this.data.numWorks;
    },
    numSlides() {
      return this.data.numSlides;
    },
    numImages() {
      return this.data.numImages;
    },
    numVideo() {
      return this.data.numVideo;
    },
    numAudio() {
      return this.data.numAudio;
    },
    showWrapperClasses() {
      let cls = [
        "curr-index-" + this.currIndex,
        "num-loaded-" + this.loadedSet.length
      ];
      if (this.switching) {
        cls.push("switching");
      }
      return cls;
    }
  },
  methods: {
    close() {
      this.$parent.close(this.currIndex);
    },
    handleClose() {
      if (this.isDetailPath()) {
        this.close();
      }
    },
    handleNext() {
      if (this.isDetailPath()) {
        this.next();
      }
    },
    handlePrev() {
      if (this.isDetailPath()) {
        this.prev();
      }
    },
    nextPrev(mode = "next") {
      if (!this.moving) {
        const { path } = this.$route;
        const parts = path.length > 1 ? path.substring(1).split("/") : [];
        const refFilter = parts.length > 1 ? parts[1] : "";
        const filterAlias = this.filter.replace(/^with/, "").toLowerCase();
        if (filterAlias === refFilter) {
          this.moving = true;
          const offset = mode === "next" ? 1 : -1;
          const lastIndex = this.slides.length - 1;
          let nextIndex = this.currIndex + offset;
          let close = false;
          if (nextIndex < 0) {
            nextIndex = lastIndex;
          } else if (nextIndex > lastIndex) {
            nextIndex = 0;
            close = true;
          }
          this.setCurrent(nextIndex);
          if (close) {
            this.close();
          }
          setTimeout(() => {
            this.moving = false;
          }, 500);
        }
      }
    },
    setCurrent(nextIndex) {
      if (this.currIndex !== nextIndex) {
        this.currIndex = nextIndex;
      }
    },
    next() {
      return this.nextPrev("next");
    },
    prev() {
      return this.nextPrev("prev");
    },
    setPath() {
      const secPath = this.filter.replace(/^with/, "").toLowerCase();
      const newPath = ["/review", secPath, this.currIndex].join("/");
      if (this.$route.path !== newPath) {
        this.$router.push(newPath);
      }
    },
    isDetailPath() {
      return this.$parent.showDetail;
    }
  }
};
</script>